export const schema = {
  "properties": {
    "name": {
      "type": "string"
    },
    "props": {
      "type": "array",
      "uniqueItems": true,
      "items": {
        "type": "string",
        "oneOf": []
      }
    }
  }
};